import React from 'react';
import { Link } from 'react-router-dom';



const Footer = () => {
  const companyDetails = {
    name: 'Dershelas Ltd',
    address: 'Stadiou 15, 2867 Nicosia, Cyprus',
    email: 'support@learnaihub.net',
  };

  const legalLinks = [
    { label: 'Privacy Policy', path: '/privacy-policy' },
    { label: 'Terms & Conditions', path: '/terms-and-conditions' },
    { label: 'Imprint', path: '/imprint' },
  ];

  return (
    <>
    <section className="border-t border-zinc-200 bg-[zinc-50] py-16 md:py-24 relative overflow-hidden">
      <div className="absolute left-[40%] top-[85%] w-96 h-96 bg-[#f59e0b] rounded-full blur-[100px] opacity-40 pointer-events-none"></div>

      <div className="relative z-10 mx-auto max-w-4xl px-4 sm:px-6 text-center lg:px-12">


        <h3 className="mb-6 text-2xl sm:text-3xl md:text-5xl font-black tracking-tighter text-zinc-950">
          Ready to get AI ready?
        </h3>

        <p className="mb-10 text-base sm:text-lg font-medium text-zinc-600">
          Join 12,000+ professionals who have already upgraded their skillsets. Start learning with practical, ROI-driven lessons today.
        </p>
<div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center w-full">
 

             <Link
                    to="/pricing"
                    className="bg-[#09090B] text-white border border-[#09090B] px-8 py-4 rounded-xl font-bold text-lg text-center hover:bg-white hover:text-zinc-950 hover:border-[#09090B] transition-all shadow-xl shadow-zinc-200"
                >
                    View Pricing
                </Link>
                </div>
      </div>
    </section>

    <footer className="bg-[#09090B] text-zinc-400 py-10 md:pt-16 md:pb-8 border-t border-zinc-800/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.45fr_0.8fr_0.8fr_1.35fr] gap-8 lg:gap-10 items-start" >
        
        {/* Brand Column */}
        <div className="sm:col-span-2 lg:col-span-1 flex flex-col items-start w-fit">
         <Link to="/" className="relative z-10 flex shrink-0 items-center gap-2 group" aria-label="Learn AI Hub home">
                     <div className="absolute -inset-2 bg-gradient-to-r from-amber-500/20 to-amber-500/20 rounded-full blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                     <img
                       src="/logo-learn-ai-hub.png"
                       alt="Learn AI Hub"
                       width="140"
                       height="40"
                       className="relative z-10 h-10 w-auto"
                     />
                   </Link>
          <p className="text-xs sm:text-sm text-zinc-300 leading-relaxed mb-8 mt-2 w-full max-w-xs">
            Empowering the next generation of AI engineers with hands-on, architectural learning.
          </p>
  
          <div className="flex items-center gap-4">
            <img src="/MastercardPay.svg" alt="master-card" width="42" height="27" />
            <img src="/sepaPay.svg" alt="sepa" width="88" height="24" />
            <img src="/visaPay.svg" alt="visa" width="37" height="23" />
          </div>
        </div>

        {/* Navigation Links (same as header) */}
        <div className="text-left md:text-left w-fit lg:-ml-4">
          <h2 className="text-white font-bold mb-4 md:mb-3 text-base">Quick links</h2>
          <ul className="space-y-2 text-xs sm:text-sm md:grid md:grid-cols-1 md:gap-x-8 md:gap-y-2 md:space-y-0 justify-between">
            <li><Link to="/" className="inline-flex min-h-8 items-center hover:text-white hover:underline transition-colors">Home</Link></li>
            <li><Link to="/library" className="inline-flex min-h-8 items-center hover:text-white hover:underline transition-colors">Library</Link></li>
            <li><Link to="/pricing" className="inline-flex min-h-8 items-center hover:text-white hover:underline transition-colors">Pricing</Link></li>
            <li><Link to="/unsubscribe" className="inline-flex min-h-8 items-center hover:text-white hover:underline transition-colors">Unsubscribe</Link></li>

          </ul>
        </div>

        <div className="text-left md:text-left w-fit lg:-ml-4">
          <h2 className="text-white font-bold mb-3 md:mb-3 text-base">Legal</h2>
          <ul className="space-y-2 text-xs sm:text-sm md:grid md:grid-cols-1 md:gap-x-8 md:gap-y-2 md:space-y-0 justify-between">
            {legalLinks.map((link) => (
              <li key={link.path}>
                <Link to={link.path} className="inline-flex min-h-8 items-center hover:text-white hover:underline transition-colors">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="text-left md:text-left w-full">
          <h2 className="text-white font-bold mb-3 md:mb-3 text-base">Company Details</h2>
          <ul className="space-y-2 text-xs sm:text-sm md:grid md:grid-cols-1 md:gap-x-8 md:gap-y-2 md:space-y-0 justify-between">
            <li className="min-h-8 flex items-center">
              Company Name: {companyDetails.name}
            </li>
            <li className="min-h-8 flex items-center">
              Company Address: {companyDetails.address}
            </li>
            <li className="min-h-8 flex items-center">
              Email:{' '}
              <a href={`mailto:${companyDetails.email}`} className="transition-colors hover:text-white">
                {companyDetails.email}
              </a>
            </li>
          </ul>
        </div>

      </div>

    

      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 mt-10 md:mt-16 pt-6 md:pt-8 border-t border-zinc-800/80 text-xs sm:text-sm text-center text-zinc-300">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row md:text-center">
          <p className='mx-auto'>&copy; 2026 Learn AI Hub All rights reserved.</p>
         
        </div>
      </div>
    </footer>
    </>
  );
};

export default Footer;
